// regexValidators.js
import { regexValue } from "constant/constantValue";

const {
  EMAIL_REGEX,
  URL_REGEX,
  NAME_REGEX,
  IFSC_CODE_REGEX,
  IMAGE_FILE_REGEX,
  ACCOUNT_NUMBER_REGEX,
  DOCUMENT_FILE_REGEX,
  GENERIC_FILE_REGEX,
  PDF_FILE_REGEX,
  EXCEL_FILE_REGEX,
  MOBILE_NUMBER_REGEX,
  AUDIO_FILE_REGEX,
  VIDEO_FILE_REGEX,
  PAN_CARD_REGEX,
  PASSWORD_REGEX,
  YOUTUBE_LINK_REGEX,
  EXTRACT_YOUTUBE_ID_REGEX,
  EXTRACT_VIMEO_ID_REGEX,
  GST_NUMBER_REGEX,
} = regexValue;

export const validateEmail = (input) => EMAIL_REGEX.test(input);
export const validateUrl = (input) => URL_REGEX.test(input);
export const validateName = (input) => NAME_REGEX.test(input);
export const validateImageFile = (input) => IMAGE_FILE_REGEX.test(input);
export const validateIfscCode = (input) => IFSC_CODE_REGEX.test(input);
export const validateAccountNumber = (input) =>
  ACCOUNT_NUMBER_REGEX.test(input);
export const validateDocumentFile = (input) => DOCUMENT_FILE_REGEX.test(input);
export const validateGenericFile = (input) => GENERIC_FILE_REGEX.test(input);
export const validatePdfFile = (input) => PDF_FILE_REGEX.test(input);
export const validateExcelFile = (input) => EXCEL_FILE_REGEX.test(input);
export const validateMobileNumber = (input) => MOBILE_NUMBER_REGEX.test(input);
export const validateAudioFile = (input) => AUDIO_FILE_REGEX.test(input);
export const validateVideoFile = (input) => VIDEO_FILE_REGEX.test(input);
export const validatePassword = (input) => PASSWORD_REGEX.test(input);
export const validateYoutubeLink = (input) => YOUTUBE_LINK_REGEX.test(input);
export const extractYoutubeId = (input) => {
  const match = input.match(EXTRACT_YOUTUBE_ID_REGEX);
  return match ? match[1] : null;
};
export const extractVimeoId = (input) => {
  const match = input.match(EXTRACT_VIMEO_ID_REGEX);
  return match ? match[1] : null;
};
export const validatePanCard = (input) => PAN_CARD_REGEX.test(input);
export const validateGstNumber = (input) => GST_NUMBER_REGEX.test(input);
